import React from 'react';
import { Link } from 'react-router-dom';

function NotFoundPage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center">
      <div className="text-8xl font-bold text-gray-200 mb-4">404</div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">
        Pagina non trovata
      </h1>
      <p className="text-gray-500 mb-6">
        La pagina che stai cercando non esiste o è stata spostata.
      </p>
      <Link to="/" className="btn btn-primary">
        Torna alla Dashboard
      </Link>
    </div>
  );
}

export default NotFoundPage;
